/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Input from "@mui/material/Input";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";
import { FilledInput } from "@mui/material";
import link from "assets/theme/components/link";

function AddAdvertisement({ onClose, onSuccess, onFailed, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [editData, setEditData] = useState(editFormData);

  const [formData, setFormData] = useState({
    title: editData ? editData.title : "",
    image: editData ? editData.image : "",
    link: editData ? editData.link : "",
    status: editData.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      console.log("Form data submitted:", formData);
      const endpoint = isEdit
        ? `/admin/advertisement/update/${editData._id}`
        : "/admin/advertisement"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create

      // Make the API request
      const response = await method(endpoint, formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating room type:", response.data.message);
          // showing failed message in snackbar
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating advertisement:", error);
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    let payloadData = {
      fileName: file.name,
      fileType: file.type,
    };
    const preSignedUrl = await apiClient.post("/home/s3/uploadFile", payloadData);
    console.log("preSignedUrl:", preSignedUrl);
    const response = await fetch(preSignedUrl.data.url, {
      method: "PUT",
      body: file,
    });
    console.log("Response:", response);
    setSelectedFile(file);
    if (response.ok) {
      console.log("File uploaded successfully");
      setFormData({
        ...formData,
        image: preSignedUrl.data.url.split("?")[0],
      });
    }
  };

  return (
    <Card id="add-advertisement">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Link"
                name="link"
                value={formData.link}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="text" component="label">
                <Input type="file" hidden onChange={handleFileChange} />
              </Button>
              <Grid item xs={6}>
                {selectedFile && (
                  <MDTypography variant="caption" mt={2} color="text" fontWeight="medium">
                    <strong>Selected file:</strong> {selectedFile.name}
                  </MDTypography>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                sx={{ height: "40px" }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddAdvertisement;
